export default "__VITE_ASSET__BKKJtbUv__"